<div *ngIf="hiddenbtn===true" class="mobile-time-btns time-btns col-lg-auto row">
  <a class="col-auto w-btn" (click)="handleOnClickThisMonth();">{{ 'common.010' | translate }}</a>
  <a class="col-auto w-btn last-month" (click)="handleOnClickLastMonth();">{{ 'common.011' | translate }}</a>
  <a class="col-auto w-btn last-3-months" (click)="handleOnClickLast3Months();">{{ 'common.012' | translate }}</a>
  <a class="col-auto w-btn this-year" (click)="handleOnClickThisYear();">{{ 'common.017' | translate : { param_1: year } }}</a>
  <a class="col-auto w-btn all" (click)="handleOnClickAll();">{{ 'common.013' | translate }}</a>
</div>

<div *ngIf="hiddenbtn===false" class="mobile-time-btns time-btns col-lg-auto row">
  <a class="col-auto w-btn this-year" (click)="handleOnClickThisYear();">{{ 'common.017' | translate : { param_1: year } }}</a>
  <a class="col-auto w-btn this-year" (click)="handleOnClickLastYear();">{{ 'common.014' | translate }}</a>
  <a class="col-auto w-btn all" (click)="handleOnClickAll();">{{ 'common.013' | translate }}</a>
</div>